import type { Settings } from "./types";

export const APP_SETTINGS: Settings = {
	layout: "",
	container: "fixed",
	layouts: {
		sidebarCollapse: false,
		sidebarTheme: "light",
	},
};
